import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { Status } from '../models/Status';

@Injectable()
export class StatusService {
  constructor(private http: Http) {}

  all(): Observable<any> {
    const url = environment.api.baseUrl + environment.api.status.all;
    return this.http.get(url).map(res => {
      return res.json().map(j => new Status(j));
    });
  }

  filt(): Observable<any> {
    const url = environment.api.baseUrl + environment.api.status.filt;
    return this.http.get(url).map(res => {
      return res.json().map(j => new Status(j));
    });
  }

  get(statusId: number): Observable<any> {
    const url =
      environment.api.baseUrl +
      environment.api.status.get.replace('{statusId}', statusId.toString());
    return this.http.get(url).map(res => {
      return new Status(res.json());
    });
  }
  delete(statusId: number): Observable<any> {
    const url =
      environment.api.baseUrl +
      environment.api.status.delete.replace('{statusId}', statusId.toString());
    return this.http.delete(url).map(res => {
      return res;
    });
  }

  save(status: Status): Observable<Status> {
    const url = environment.api.baseUrl + environment.api.status.save;
    return this.http.post(url, status).map(res => {
      return res.json();
    });
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/status.service.ts